import React, { useMemo } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import ControlledTableInput from '../../form-generator-v2/ControlledTableInput';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import {
  fromCommissionTableRows,
  getCommissionConfigForInventory,
  resetCommissionFieldInFormValues,
  toCommissionTableRows
} from './inventoryCommissionHelpers';

const COMMISSION_SHEET_OPTIONS_TABLE_FIELDS = [
  { title: 'Commission Sheet Option', key: 'key', type: 'datalist-text', required: false },
  { title: 'Value', key: 'value', type: 'number', required: false }
];

const COMMISSION_SHEET_LESS_OPTIONS_TABLE_FIELDS = [
  { title: 'Commission Sheet Less Option', key: 'key', type: 'datalist-text', required: false },
  { title: 'Value', key: 'value', type: 'number', required: false }
];

const CommissionFieldTable = ({
  title,
  id,
  fieldKey,
  tableFields,
  value,
  onChange,
  dropdownOptions,
  onResetToDefault
}) => (
  <div className="mb-4">
    <ControlledTableInput
      id={id}
      title={title}
      tableFields={tableFields}
      value={toCommissionTableRows(value[fieldKey])}
      onChange={rows => onChange({ ...value, [fieldKey]: fromCommissionTableRows(rows) })}
      dropdownOptions={dropdownOptions}
      defaultHideOptions={false}
      showResetToDefault
      onResetToDefault={onResetToDefault}
    />
  </div>
);

const CommissionValuesSidebar = ({
  visible,
  onClose,
  value,
  onChange,
  appChoices,
  unitLocationId,
  numberOfSections,
  zIndex = 1050
}) => {
  const dropdownOptions = useMemo(() => {
    const { commissionOptions, commissionLessOptions } = getCommissionConfigForInventory(
      appChoices,
      unitLocationId,
      numberOfSections
    );

    return {
      commissionSheetOptions: commissionOptions.map(({ name }) => [name]),
      commissionSheetLessOptions: commissionLessOptions.map(({ name }) => [name])
    };
  }, [appChoices, unitLocationId, numberOfSections]);

  if (!value) return null;

  const resetFieldToDefault = fieldKey => {
    const nextValues = resetCommissionFieldInFormValues(
      {
        unitLocation: unitLocationId,
        numberOfSections,
        commissionSheetOptions: toCommissionTableRows(value.commissionSheetOptions),
        commissionSheetLessOptions: toCommissionTableRows(value.commissionSheetLessOptions)
      },
      appChoices,
      fieldKey
    );

    onChange({
      commissionSheetOptions: fromCommissionTableRows(nextValues.commissionSheetOptions),
      commissionSheetLessOptions: fromCommissionTableRows(nextValues.commissionSheetLessOptions)
    });
  };

  return (
    <SlidingSideBar
      visible={visible}
      title="Commission Values"
      onClose={onClose}
      showCloseButton
      zIndex={zIndex}
    >
      <div className="p-3">
        <CommissionFieldTable
          title="Commission Sheet Options"
          id="commissionSheetOptions"
          fieldKey="commissionSheetOptions"
          tableFields={COMMISSION_SHEET_OPTIONS_TABLE_FIELDS}
          value={value}
          onChange={onChange}
          dropdownOptions={dropdownOptions.commissionSheetOptions}
          onResetToDefault={() => resetFieldToDefault('commissionSheetOptions')}
        />
        <CommissionFieldTable
          title="Commission Sheet Less Options"
          id="commissionSheetLessOptions"
          fieldKey="commissionSheetLessOptions"
          tableFields={COMMISSION_SHEET_LESS_OPTIONS_TABLE_FIELDS}
          value={value}
          onChange={onChange}
          dropdownOptions={dropdownOptions.commissionSheetLessOptions}
          onResetToDefault={() => resetFieldToDefault('commissionSheetLessOptions')}
        />
      </div>
      <div className="bar-sticky-footer">
        <Row>
          <Col className="d-flex justify-content-end">
            <Button variant="success" onClick={onClose}>
              Done
            </Button>
          </Col>
        </Row>
      </div>
    </SlidingSideBar>
  );
};

export default CommissionValuesSidebar;
